import React, { useState, useEffect } from 'react';
import { Pagination } from '@mui/material';
import { Box, Stack, Typography } from '@mui/material';
import { exerciseOptions, fetchData } from '../utils/fetchData';
import ExerciseCard from './ExerciseCard';
import BG from '../assets/images/bg.jpeg';

const Exercises = ({ exercises, setExercises, bodyPart }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const exercisesPerPage = 8;

  const indexOfLastExercise = currentPage * exercisesPerPage;
  const indexOfFirstExercise = indexOfLastExercise - exercisesPerPage;
  const currentExercise = exercises.slice(
    indexOfFirstExercise,
    indexOfLastExercise
  );

  const paginate = (e, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 2500, behavior: 'smooth' });
  };

  useEffect(() => {
    const fetchExercisesData = async () => {
      let exercisesData = [];

      if (bodyPart === 'all') {
        exercisesData = await fetchData(
          'https://exercisedb.p.rapidapi.com/exercises',
          exerciseOptions
        );
      } else {
        exercisesData = await fetchData(
          `https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`,
          exerciseOptions
        );
      }

      setExercises(exercisesData);
    };

    fetchExercisesData();
  }, [bodyPart]);

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="svg"
      >
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,192L20,170.7C40,149,80,107,120,85.3C160,64,200,64,240,106.7C280,149,320,235,360,245.3C400,256,440,192,480,186.7C520,181,560,235,600,229.3C640,224,680,160,720,138.7C760,117,800,139,840,138.7C880,139,920,117,960,101.3C1000,85,1040,75,1080,85.3C1120,96,1160,128,1200,144C1240,160,1280,160,1320,165.3C1360,171,1400,181,1420,186.7L1440,192L1440,320L1420,320C1400,320,1360,320,1320,320C1280,320,1240,320,1200,320C1160,320,1120,320,1080,320C1040,320,1000,320,960,320C920,320,880,320,840,320C800,320,760,320,720,320C680,320,640,320,600,320C560,320,520,320,480,320C440,320,400,320,360,320C320,320,280,320,240,320C200,320,160,320,120,320C80,320,40,320,20,320L0,320Z"
        ></path>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,192L20,170.7C40,149,80,107,120,85.3C160,64,200,64,240,106.7C280,149,320,235,360,245.3C400,256,440,192,480,186.7C520,181,560,235,600,229.3C640,224,680,160,720,138.7C760,117,800,139,840,138.7C880,139,920,117,960,101.3C1000,85,1040,75,1080,85.3C1120,96,1160,128,1200,144C1240,160,1280,160,1320,165.3C1360,171,1400,181,1420,186.7L1440,192L1440,0L1420,0C1400,0,1360,0,1320,0C1280,0,1240,0,1200,0C1160,0,1120,0,1080,0C1040,0,1000,0,960,0C920,0,880,0,840,0C800,0,760,0,720,0C680,0,640,0,600,0C560,0,520,0,480,0C440,0,400,0,360,0C320,0,280,0,240,0C200,0,160,0,120,0C80,0,40,0,20,0L0,0Z"
        ></path>
      </svg>

      <Box
        id="exercises"
        sx={{
          mt: { lg: '110px' },
        }}
        mt="50px"
        p="20px"
      >
        <Typography
          className="demo"
          color="#FF2625"
          align="center"
          variant="h2"
          mb="150px"
          mt="150px"
          fontWeight={600}
        >
          <span style={{ color: '#fff' }}>Show</span> demo
          <span style={{ color: '#fed136' }}>.</span>
        </Typography>

        <Stack
          direction="row"
          sx={{ gap: { lg: '110px', xs: '50px' } }}
          flexWrap="wrap"
          justifyContent="center"
        >
          {currentExercise.map((exercise, index) => (
            <ExerciseCard key={index} exercise={exercise} />
          ))}
        </Stack>

        <Stack mt="100px" alignItems="center">
          {exercises.length > 8 && (
            <Pagination
              color="error"
              defaultPage={1}
              count={Math.ceil(exercises.length / exercisesPerPage)}
              page={currentPage}
              onChange={paginate}
              size="small"
            />
          )}
        </Stack>
      </Box>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="svg"
      >
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,224L34.3,218.7C68.6,213,137,203,206,213.3C274.3,224,343,256,411,250.7C480,245,549,203,617,165.3C685.7,128,754,96,823,117.3C891.4,139,960,213,1029,218.7C1097.1,224,1166,160,1234,122.7C1302.9,85,1371,75,1406,69.3L1440,64L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"
        ></path>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,224L34.3,218.7C68.6,213,137,203,206,213.3C274.3,224,343,256,411,250.7C480,245,549,203,617,165.3C685.7,128,754,96,823,117.3C891.4,139,960,213,1029,218.7C1097.1,224,1166,160,1234,122.7C1302.9,85,1371,75,1406,69.3L1440,64L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"
        ></path>
      </svg>

      <img src={BG} alt="bg" className="bg" />
    </>
  );
};

export default Exercises;
